<template>
  <v-card :loading="loading">
    <v-toolbar flat>
      <v-toolbar-title>{{ title }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <slot />
      <v-divider class="my-4"></v-divider>
      <v-select
        v-model="after"
        :items="placeAfter"
        label="Поставить блок после"
      />
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="primary" text @click="save">Сохранить</v-btn>
    </v-card-actions>
    <snackbar v-bind.sync="snackbar" />
  </v-card>
</template>

<script>
import Snackbar from "../../Snackbar";

export default {
  name: "FormTemplate",
  components: { Snackbar },
  props: {
    data: {
      type: Object,
      required: true,
      article_id: Number,
      lang: String,
      sort: Number
    },
    blocks: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    snackbar: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      after: this.data.after,
      override: {}
    };
  },
  computed: {
    placeAfter() {
      const result = [
        { text: "не двигать", value: 0 },
        { text: "поставить первым", value: -1 },
        { text: "в конец", value: -2 }
      ];
      this.blocks.forEach((block) => {
        if (typeof block.sort === "undefined") return;
        if (block.id === this.data.id) return;
        result.push(this.blockToPlaceItem(block));
      });
      return result;
    }
  },
  methods: {
    blockToPlaceItem(block) {
      const result = { value: block.id, text: "" };
      const sort = block.sort+1;
      switch (block.type) {
        case "h2":
          result.text = "[" + sort + "] " + block.content;
          break;
        case "text":
          result.text = "[" + sort + "] текстовый блок";
          break;
        case "image":
          result.text = "[" + sort + "] изображение";
          break;
        case "image-text":
          result.text = "[" + sort + "] изображение с текстом";
          break;
        case "youtube":
          result.text = "[" + sort + "] YouTube";
          break;
        default:
          result.text = "[" + sort + "] неизвестный";
      }
      return result;
    },
    save() {
      if (this.loading) return;
      const payload = Object.assign(
        {},
        this.data,
        {after: this.after }
      );
      this.$emit('save', payload);
    }
  }
};
</script>
